'use strict'

module.exports = (message) => new Buffer(JSON.stringify(message))



//////////////////
// WEBPACK FOOTER
// ./~/y-ipfs-connector/src/encode.js
// module id = 335
// module chunks = 0